import { IconLayer, TextLayer } from '@deck.gl/layers';
import { useSelector } from 'react-redux';

const PinLayer = ({ type, items, setSelectedEntityId, setModalType, setShowModal, toggleLine, entityId, setAssigPatrolId, setAssigTaskId, viewState }) => {
    const { taskStatuses, resourceStatuses } = useSelector(state => state.constants.data);

    const handleClick = (info, event) => {
        const nativeEvent = event?.srcEvent || event;
        if (event.rightButton) {
            if (info.object.type == 'TASK') {
                setAssigTaskId(info.object.id);
            }
            if (info.object.type == 'PATROL') {
                setAssigPatrolId(info.object.id);
            }
            event.preventDefault();
            return;
        }
        if (!info?.object) return;

        if (nativeEvent.ctrlKey) {
            const { id } = info.object;
            let entity;

            entity = items.find(t => t.id == id);
            setModalType(type);
            setSelectedEntityId(entity.id);
            setShowModal(true);

        } else {
            toggleLine(info.object.id, type);
        }

    };

    const pins = items.map(item => {
        let position = { lat: null, lng: null };
        let statusName;
        let assignmentsCount = '';
        
        if (type == 'PATROL' ) {

            if (item.status?.code == 'OFFD' || item.status?.code == 'BASE') {
                if(item.baseLocation && item.baseLocation.lat && item.baseLocation.lng) {
                    position.lat = parseFloat(item.baseLocation.lat);
                    position.lng = parseFloat(item.baseLocation.lng);
                    statusName = resourceStatuses.find(s => s.id == item.status.id)?.code;
                    assignmentsCount = 'Queue: ' + item.assignedTasks.length;
                }
            } else {
                if(item.location && item.location.lat && item.location.lng) {
                    position.lat = parseFloat(item.location.lat);
                    position.lng = parseFloat(item.location.lng);
                    statusName = resourceStatuses.find(s => s.id == item.status.id)?.code;
                    assignmentsCount = 'Queue: ' + item.assignedTasks.length;
                }
            }
        }
        
        if (type == 'TASK' && item.location && item.location.lat && item.location.lng) {

            position.lat = parseFloat(item.location.lat);
            position.lng = parseFloat(item.location.lng);
            statusName = taskStatuses.find(s => s.id == item.statusId)?.code;
        }

        let iconUrl;
        if (type == 'PATROL') {
            if (item.resourceType.includes(2)) {
                iconUrl = `/images/markers/patrol-recy.png`;
            } else {
                iconUrl = `/images/markers/patrol.png`;
            }
        }
        if (type == 'TASK') {
            if (entityId == item.id) {
                iconUrl = `/images/markers/selected-task2.png`;
            } else {

                iconUrl = `/images/markers/task.png`;
            }
        }

        return ({
            ...item,
            position: [position.lng, position.lat],
            iconUrl,
            statusName,
            assignmentsCount,
            type
        });
    });

    const zoom = viewState.zoom;
    const offsetMultiplier = 4; // tweak this to control how fast the offset shrinks
    const baseOffset = 24;

    return [new IconLayer({
        id: `${type}-icon-layer`,
        data: pins,
        pickable: true,
        getPixelOffset: () => {
            let scaledOffset = Math.min(9, Math.max(6, baseOffset - (zoom - 4) * offsetMultiplier));
            if(zoom > 11) {
                scaledOffset = 24;
            }
            return type === 'PATROL' ? [scaledOffset, 0] : [-scaledOffset, 0];
          },
        getIcon: (d) => ({ url: d.iconUrl, width: 59, height: 49 }),
        sizeScale: 1,
        getPosition: d => d.position,
        getSize: () => {
            const scaled = (zoom - 4) * 6;
            return Math.min(59, Math.max(20, scaled));
        },
        getColor: () => [255, 0, 0],
        onClick: handleClick,
        updateTriggers: {
            getSize: zoom
        }
    }),
    new TextLayer({
        id: `text-layer-${type}`,
        data: pins,
        getPosition: d => d.position,
        getPixelOffset: () => {
            let scaledOffset = Math.min(9, Math.max(6, baseOffset - (zoom - 4) * offsetMultiplier));
            if(zoom > 11) {
                scaledOffset = 24;
            }
            return type === 'PATROL' ? [scaledOffset, -20] : [-scaledOffset, -10];
          },
        getText: d => d.statusName + '\n' + d.assignmentsCount,
        getSize: () => {
            const scaled = (zoom - 4) * 1.5;
            return Math.min(12, Math.max(3, scaled));
        },
        getTextAnchor: 'middle',
        getAlignmentBaseline: 'top',
        getColor: d => (entityId == d.id || type == 'TASK') ? [255, 255, 255] : [0, 0, 0], // black text
        sizeUnits: 'pixels',
        sizeScale: 1,
        fontFamily: 'Arial, sans-serif',
        updateTriggers: {
            getSize: viewState.zoom
        }
    })]

}

export default PinLayer;